import { render, staticRenderFns } from "./DeMinimisTaxCalculator.vue?vue&type=template&id=933e1c84&scoped=true&"
import script from "./DeMinimisTaxCalculator.vue?vue&type=script&lang=js&"
export * from "./DeMinimisTaxCalculator.vue?vue&type=script&lang=js&"
import style0 from "./DeMinimisTaxCalculator.vue?vue&type=style&index=0&id=933e1c84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933e1c84",
  null
  
)

export default component.exports